import { CancelToken } from 'axios';
import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import {
  IVODUpdateThumbnailParams,
  IVODUpdateThumbnailResponse,
} from '~/Models/DTO/VideoOnDemand.models';
export const useRequestUpdateThumbnailVOD = (cancelToken?: CancelToken) => {
  const {
    data: vodThumbnailResponse,
    error: vodUpdateThumbnailError,
    isLoading: isVideoThumbnailUpdateLoading,
    mutate: updateThumbnail,
    isSuccess: isVideoUpdateThumbnailSuccess,
  } = useMutation<IVODUpdateThumbnailResponse, IErrorResponse, IVODUpdateThumbnailParams>(
    async (params: IVODUpdateThumbnailParams) =>
      requestReactQuery<IVODUpdateThumbnailResponse>({
        url: routeReplacer(VIDEO_INTEGRATION_SERVICE_URLS.VOD_UPDATE_THUMBNAIL, {
          videoId: params.videoId,
        }),
        data: {
          position: params.position,
          width: params.width,
        },
        config: { method: 'POST', cancelToken },
      }),
    {
      mutationKey: REQUEST_ACTIONS.UPLOAD_VOD_VIDEO,
    },
  );

  return {
    vodUploadError: vodUpdateThumbnailError as IErrorResponse,
    vodThumbnailResponse,
    updateThumbnail,
    isVideoThumbnailUpdateLoading,
    isVideoUpdateThumbnailSuccess,
  };
};
